export default __webpack_public_path__ + "static/media/IMG_1942.e58bd26a.jpg";